import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const PILLARS = [
  {
    name: "Fede",
    image:
      "https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxiaWJsZSUyMHBhZ2VzJTIwZGFya3xlbnwwfHx8fDE3OTI5NjE5MjZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Bibbia aperta in penombra",
    points: [
      "Rafforza la tua relazione con Dio.",
      "Conosci la Parola.",
      "Approfondisci la tua identità in Cristo.",
      "Impara a vivere concretamente ciò in cui credi.",
    ],
  },
  {
    name: "Fitness",
    image:
      "https://images.unsplash.com/photo-1590487988256-9ed24133863e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZ3ltJTIwZml0bmVzc3xlbnwwfHx8fDE3OTI5NjE5MjZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Attrezzi da palestra in penombra",
    points: [
      "Prenditi cura del corpo.",
      "Costruisci disciplina.",
      "Allena l'autocontrollo.",
      "Sviluppa abitudini sane e una mentalità orientata alla responsabilità.",
    ],
  },
  {
    name: "Famiglia",
    image:
      "https://images.unsplash.com/photo-1640273296013-e4b54eaf52eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxjb3VwbGUlMjBzdW5zZXQlMjBuYXR1cmV8ZW58MHx8fHwxNzkyOTYxOTI2fDA&ixlib=rb-4.1.0&q=85",
    alt: "Coppia che si tiene per mano al tramonto",
    points: [
      "Coltiva relazioni sane.",
      "Prenditi cura del matrimonio.",
      "Cresci nelle responsabilità familiari.",
      "Costruisci relazioni con altri cristiani.",
    ],
  },
];

export const MethodSection = () => (
  <section id="metodo" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Il metodo Tempio Vivo"
        title={
          <>
            Tre pilastri.
            <br />
            Un solo centro: <span className="text-[#C9A45C]">Dio</span>.
          </>
        }
        testid="method-heading"
      />
      <div className="grid gap-6 md:grid-cols-3 md:gap-8">
        {PILLARS.map((pillar, i) => (
          <Reveal key={pillar.name} delay={0.1 * i}>
            <article
              data-testid={`pillar-card-${pillar.name.toLowerCase()}`}
              className="group h-full overflow-hidden rounded-sm border border-[#1B1B1B] bg-[#121212] transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A45C]/50 hover:shadow-[0_4px_30px_rgba(201,164,92,0.15)]"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={pillar.image}
                  alt={pillar.alt}
                  loading="lazy"
                  className="h-full w-full object-cover opacity-70 transition-all duration-500 group-hover:scale-105 group-hover:opacity-90"
                />
                <div
                  className="absolute inset-0 bg-gradient-to-t from-[#121212] to-transparent"
                  aria-hidden="true"
                />
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl font-semibold uppercase tracking-widest text-[#C9A45C]">
                  {pillar.name}
                </h3>
                <ul className="mt-5 space-y-3">
                  {pillar.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-start gap-3 text-sm leading-relaxed text-[#B8B8B8]"
                    >
                      <span
                        className="mt-2 h-px w-4 shrink-0 bg-[#C9A45C]"
                        aria-hidden="true"
                      />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-14 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#B8B8B8]">
          Non lavoriamo su una sola parte di te.
        </p>
        <p className="font-display mt-3 text-2xl font-semibold uppercase text-white sm:text-3xl">
          Lavoriamo sulla persona intera,{" "}
          <span className="text-[#C9A45C]">con Dio al centro</span>.
        </p>
        <p className="mt-6 text-xs uppercase tracking-[0.25em] text-[#8F7138]">
          La famiglia comprende sia quella biologica sia quella spirituale.
        </p>
      </Reveal>
    </div>
  </section>
);
